import { Injectable, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionTimeoutService {
  private timeout: any;
  private readonly sessionTime = 15 * 60 * 1000; // 15 minutes

  constructor(private router: Router) {
    this.resetTimer();
  }

  resetTimer() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.logout();
    }, this.sessionTime);
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/Login']);
  }

}
